import {
  EmbeddedCheckoutProvider,
  EmbeddedCheckout,
} from "@stripe/react-stripe-js";

import { Box } from "@chakra-ui/react";
import { stripePromise } from "../../../../util";
import { useStripeClientSecretForEmbeddedForm } from "./useStripeClientSecretForEmbeddedForm";

export function PaymentFormEmbedded() {
  const { clientSecret } = useStripeClientSecretForEmbeddedForm();

  const options = {
    clientSecret,
  };
  return (
    <Box w="full">
      {clientSecret && (
        <EmbeddedCheckoutProvider stripe={stripePromise} options={options}>
          <EmbeddedCheckout />
        </EmbeddedCheckoutProvider>
      )}
    </Box>
  );
}
